import Service, { service } from "@ember/service";
import { NotFoundError } from "glesys-controlpanel/utils/errors";
import type Route from "@ember/routing/route";
import type AbilitiesService from "ember-can/services/abilities";

export default class AvailableServicesService extends Service {
  @service declare abilities: AbilitiesService;

  requireAccessTo(route: Route, ...serviceKeys: string[]): void {
    const { project } = route.modelFor("organization") as { project: unknown };

    if (!project) {
      throw new NotFoundError();
    }

    if (this.abilities.cannot("show service for project", project, { serviceKeys })) {
      throw new NotFoundError();
    }
  }
}
